import * as React from "react";
const SvgFiRrBookAlt = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-book-alt_svg__a)">
      <path
        fill="#062147"
        d="M22.2 2.163a5 5 0 0 0-4.1-1.081l-3.822.694A4 4 0 0 0 12 3.065a4 4 0 0 0-2.284-1.289L5.9 1.082A5 5 0 0 0 0 6v10.793a5 5 0 0 0 4.105 4.919l6.286 1.143a9 9 0 0 0 3.218 0l6.291-1.143a5 5 0 0 0 4.1-4.919V6a4.98 4.98 0 0 0-1.8-3.837M11 20.928a7 7 0 0 1-.252-.041l-6.285-1.142A3 3 0 0 1 2 16.793V6a3 3 0 0 1 3.54-2.951l3.82.7A2 2 0 0 1 11 5.712zm11-4.135a3 3 0 0 1-2.463 2.952l-6.285 1.142a7 7 0 0 1-.252.041V5.712a2 2 0 0 1 1.642-1.968l3.821-.7A3 3 0 0 1 22 6z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-book-alt_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrBookAlt;
